import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { NaploService } from '../naplo.service';
import { NaploMenuService, LathatoFomenu } from '../naplo-menu.service';
import { NaploMenupont } from '../naplo-menu';

/**
 *  A NAPLO FŐMENÜJE – a modul kezdőlapja, ügyfélválasztás után.
 *
 *  A könyvelőprogramok főképernyőjét követi: felül a főmenük nagy gombjai, egy elválasztó alatt a
 *  kiválasztott főmenü almenüi csempékként. Ugyanazt a menüt mutatja, mint a fejléc lenyíló
 *  panele (NaploMenuService), csak nagyban – egy helyen lehet áttekinteni, mi érhető el.
 */
@Component({
  selector: 'app-naplo-fomenu',
  templateUrl: './fomenu.component.html',
  styleUrls: ['../naplo-shared.scss', './fomenu.component.scss'],
})
export class FomenuComponent implements OnInit, OnDestroy {
  menuk: LathatoFomenu[] = [];
  valasztott: string | null = null;
  /** A főoldali „Első beállítás" gomb piros, ha a varázsló lépései közül nincs mind kész. */
  beallitasHianyos = false;
  private sub?: Subscription;
  private static readonly TAR = 'naplo-fomenu-utolso';

  constructor(private naplo: NaploService, private menu: NaploMenuService) {}

  /** A gyorsbillentyű módosítója a súgóban: Macen ⌥ Option, máshol Alt. */
  readonly modBillNev = /Mac|iPhone|iPad|iPod/i.test(navigator.platform || navigator.userAgent) ? '⌥ Option' : 'Alt';

  get aktiv() { return this.naplo.aktiv; }
  get pontok(): NaploMenupont[] { return this.menuk.find((x) => x.f.kulcs === this.valasztott)?.pontok || []; }

  /*  AMÍG AZ ÉV NINCS MEGNYITVA, a csempék halványak. Kettős könyvvitelnél a könyvelés a nyitó
   *  egyenlegekkel kezdődik: nyitás nélkül a kivonat, a mérleg és a naplók is féligazságot
   *  mutatnának. A csempék ettől még kattinthatók (a beállításokhoz el kell jutni), csak
   *  látszik, hogy a év még nincs megnyitva – és egy kattintással odajutsz. */
  //  Az állapot a NaploService-ben él (a fejléc menüje és a könyvelőablak is ezt nézi).
  get zarasAllapot(): any { return this.naplo.zarasAllapot; }
  get nyitasKell(): boolean { return this.naplo.nyitasKell; }
  private async nyitasEllenoriz() { await this.naplo.nyitasFrissit(); }
  /*  MI MARAD ÉLŐ NYITATLAN ÉVBEN.
   *   - a Nyitás / zárás, mert épp ott lehet megnyitni az évet,
   *   - az Ügyfelek, mert az nem a céghez tartozik: onnan lehet MÁSIK ügyfelet választani
   *     (különben a nyitatlan év csapdába zárná a felhasználót). */
  nyitasPont(p: NaploMenupont): boolean {
    const kulcs = String((p as any)?.kulcs || '');
    return kulcs === 'zaras' || kulcs === 'ugyfelek'
      || String((p as any)?.query?.nezet || '') === 'zaras'
      || String((p as any)?.ut || '').startsWith('/naplo/ugyfelek');
  }
  /**  Nyitatlan évnél a többi csempe nem kattintható (és halvány). */
  tiltott(p: NaploMenupont): boolean { return this.nyitasKell && !this.nyitasPont(p); }

  nyitasraUgras() { this.menu.nyit({ kulcs: 'zaras', cim: 'Nyitás / zárás', leiras: '', ikon: 'lock-open-outline', ut: '/naplo/kettos', query: { nezet: 'zaras' }, jog: '/naplo/kettos' } as any); }

  async ngOnInit() {
    await this.naplo.init();
    this.sub = this.menu.lathato$.subscribe((m) => {
      this.menuk = m || [];
      if (!this.valasztott || !this.menuk.some((x) => x.f.kulcs === this.valasztott)) {
        let tarolt: string | null = null;
        try { tarolt = localStorage.getItem(FomenuComponent.TAR); } catch { /* privát mód */ }
        this.valasztott = this.menuk.some((x) => x.f.kulcs === tarolt) ? tarolt : (this.menuk[0]?.f.kulcs || null);
      }
    });
    //  Egyszerre (2026-11-05 – eddig egymás után); az év-nyitás állapotát a NaploService.init már lekérte, csak
    //  akkor kérjük újra, ha még nincs meg.
    await Promise.all([
      this.menu.frissit(),
      this.naplo.zaras$.value == null ? this.nyitasEllenoriz() : Promise.resolve(),
      this.beallitasAllapot(),
    ]);
  }
  ngOnDestroy() { this.sub?.unsubscribe(); }

  /** A varázsló összegzője: ha nincs minden lépés kész, a főoldali gomb pirosan jelez. */
  private async beallitasAllapot() {
    const id = this.aktiv.ugyfelId;
    if (!id) { this.beallitasHianyos = false; return; }
    try {
      const r: any = await this.naplo.get(`/beallitas-allapot/${id}?ev=${this.aktiv.ev}`);
      this.beallitasHianyos = !!r && r.mind_kesz === false;
    } catch { this.beallitasHianyos = false; }
  }

  valaszt(k: string) {
    this.valasztott = k;
    try { localStorage.setItem(FomenuComponent.TAR, k); } catch { /* nem kritikus */ }
  }
  nyit(p: NaploMenupont) {
    if (this.tiltott(p)) return;   // nyitatlan évben csak a nyitás/zárás nyitható
    this.menu.nyit(p);
  }
}
